import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import thumbnail from '../lib/thumbnail-helper';
import { imageInfoShape } from '../lib/shapes';
import styles from './ThumbnailList.css';
import LazyImage from './LazyImage';

class ThumbnailList extends Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      imageInfo: imageInfoShape,
    })).isRequired,
    hideIfListofOne: PropTypes.bool,
    styles: PropTypes.objectOf(PropTypes.string),
  };

  static defaultProps = {
    hideIfListofOne: true,
  };

  render() {
    const { images, hideIfListofOne } = this.props;

    if (hideIfListofOne && images.length <= 1) {
      return null;
    }

    return (
      <ul styleName="thumbnails">
        {
          images.map((image, index) => {
            const thumbnailSrc = thumbnail(image.imageInfo.src);
            return (
              <li key={`image-${index}`}>
                <Link target="_self" to={image.url} activeClassName={this.props.styles.on}>
                  <LazyImage src={thumbnailSrc} />
                </Link>
                <link rel="prefetch" href={thumbnailSrc} />
                <link rel="prefetch" href={image.imageInfo.src} />
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default CSSModules(ThumbnailList, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/components/ThumbnailList.js